/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * LoginPage.tsx
 */

import React from 'react';
import HiloReactComponent from "./HiloReactComponent";
import Spinner from "../element/Spinner";

interface State {
    timeElapsedMs: number;
    skipped: boolean;
}

interface Props {
}

const DEFAULT_TIME_MS = 1000;
const INTERVAL_STEP_MS = 100;

export default class Splashscreen extends HiloReactComponent<Props, State> {

    constructor(props: Props, state: State) {
        super(props, state);

        this._refreshElapsedTime = this._refreshElapsedTime.bind(this);

        this.state = {timeElapsedMs: 0, skipped: false};
    }

    /**
     * componentDidMount
     */
    public componentDidMount(): void {
        super.componentDidMount();

        setInterval(this._refreshElapsedTime, INTERVAL_STEP_MS)
    }

    /**
     * _refreshElapsedTime(
     * @private
     */
    private _refreshElapsedTime() {
        this.setState({timeElapsedMs: this.state.timeElapsedMs + INTERVAL_STEP_MS})
    }

    /**
     * skip
     */
    public skip() {
        this.setState({skipped: true});
    }

    private _hide() {

    }

    private _show() {

    }

    /**
     * render
     * @return{ReactNode | undefined | any}
     */
    public render() {
        const {timeElapsedMs, skipped} = this.state;
        const showChildren = timeElapsedMs >= DEFAULT_TIME_MS && skipped;

        return <div className={"splashscreen"}>
            {
                showChildren ? this.props.children : <Spinner large={true}/>
            }
        </div>;
    }
}